import Cookies from 'js-cookie';
import {CONSTANTS, SESSION} from './framework';

// TODO: 和账号信息相关内容做整合
export const getUserId = () => CONSTANTS.userid || '';

export const getEopAccountId = () => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get('accountId') || '';
};

export const isAgent = () => SESSION.isAgent?.() || false;

export const isAgentUser = () => SESSION.isAgentUser?.() || false;

// 获取主账号 Id
export const getMasterId = () => Cookies.get('bce-org-master-id');

// 主账号代理子账号登录（即主账号切换到子账号）
export const isDelegate = () => Cookies.get('bce-org-delegate') === 'true';

// 子用户登录
export const isSubUser = () => Cookies.get('bce-subuser-info') === 'true';

// 子账户登录（非主账号代理登录）
export const isSubAccount = () => !!(Cookies.get('bce-login-accountid') !== getMasterId()
    && getMasterId() && !isDelegate() && !isSubUser());

// 当前登录账户名
export const getAccountDisplayName = () => Cookies.get('bce-login-display-name');

// 虚商子账户
export const isVSSubAccount = () => !!(Cookies.get('bce-login-accountid') !== getMasterId()
    && getMasterId() && getAccountDisplayName()?.startsWith('VS'));
